import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
};

export const adminGetBenefits = createQueryFn(
  QueryNameSpace.adminGetBenefits,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], string[]>) => {
    const [, params] = queryKey;
    const res = await CoreApi.adminGetBenefits({
      ...params,
      pagecursor: pageParam,
    });

    return res.benefits;
  },
);
